'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMaximumEndTimestamp = undefined;

var _getters = require('./getters');

var getMaximumEndTimestamp = exports.getMaximumEndTimestamp = function getMaximumEndTimestamp(threadHistoryA, threadHistoryB) {
  var startA = (0, _getters.getEndTimestamp)(threadHistoryA);
  var startB = (0, _getters.getEndTimestamp)(threadHistoryB);

  if (!startA) {
    return startB;
  }

  if (!startB) {
    return startA;
  }

  return Math.max(startA, startB);
};